import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '../node_modules/@alegradev/smile-ui-next/dist/style.css'
import './index.css'
import App from './App.vue'
import router from './micro/router/router'
import i18n from './micro/languages'
import * as _s from './micro/utils/cookies'
import { getIcpFromQuery, getProductFromQuery } from './micro/utils/icpRegister'
import { getIcpCountryFromRegisterRoute } from './micro/utils/icpAuthNavigation'
import setupSentry from './sentry'
import { comesFromPOS, getQueryParameterByName } from './micro/utils/urls'
import { BASE_URL, APP_ENVIRONMENT, POS_BASE_URL } from './micro/utils/environment'
import {
  buildAgentAccessUrl,
  isAgentAccessPath,
  isAgentAccessTriggerActive,
  resolveAuthenticatedHomeUrl,
} from './micro/utils/agentAccess'

// Evitar que el chat de hubspot cargue al inicio
window.hsConversationsSettings = { loadImmediately: false }

const pinia = createPinia()
const app = createApp(App)

const runVueApp = (options?: { preserveAuth?: boolean }) => {
  if (options?.preserveAuth) {
    _s.clearNonAuthSessionData()
  } else {
    _s.clearDataOfLocalStorage()
  }
  if (APP_ENVIRONMENT !== 'local') {
    setupSentry({ app })
  }

  app.use(router).use(pinia).use(i18n).mount('#app')
}

const shouldResumeIcpFlow = () =>
  getIcpCountryFromRegisterRoute() !== null &&
  (_s.hasIcpFlowPending() || getIcpFromQuery() !== null || getProductFromQuery() !== null)

// Lógica de validación de cookie
if (_s.isValidApiTokenCookie()) {
  // Se verifica si se puede redireccionar a app.alegra.com
  if (_s.canRedirectToApp()) {
    if (isAgentAccessPath()) {
      runVueApp({ preserveAuth: true })
    } else if (shouldResumeIcpFlow()) {
      runVueApp({ preserveAuth: true })
    } else if (isAgentAccessTriggerActive()) {
      _s.incrementRedirectionCounter()
      location.replace(buildAgentAccessUrl(resolveAuthenticatedHomeUrl()))
    } else {
      // Se utiliza una cookie/contador para evitar un loop infinito.
      // Si la sesion existe pero ya caduco el contador evitara que se haga un loop infinito
      _s.incrementRedirectionCounter()

      const customUrl = getQueryParameterByName('url')

      if (comesFromPOS() || getQueryParameterByName('solution') === 'alegra-pos') {
        location.replace(POS_BASE_URL)
      } else if (customUrl) {
        location.replace(customUrl)
      } else {
        location.replace(BASE_URL)
      }
    }
  } else {
    // Si no puede redireccionarse a la app montamos la VueApp
    _s.clearApiTokenCookie()
    runVueApp()
  }
} else {
  // Si el auth token ya no es válido montamos la VueApp
  runVueApp()
}
